import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type {
  ISupplierAppsMobiscrollConnect,
  ISupplierAppsMobiscrollConnectCalendar,
  ISupplierCalendarExternalProvider,
} from './mobiscrollConnect.types';

@Timestampable
@Untrackable
export class AppsMobiscrollConnect extends AbstractDocument<ISupplierAppsMobiscrollConnect> {
  readonly collections = {};

  /** Uses `existing` when provided; otherwise reads the app doc once. */
  private async resolveData(existing?: ISupplierAppsMobiscrollConnect | null): Promise<ISupplierAppsMobiscrollConnect | null | undefined> {
    return existing !== undefined ? existing : await this.get();
  }

  async hasAccessToken(existing?: ISupplierAppsMobiscrollConnect | null): Promise<boolean> {
    return Boolean((await this.resolveData(existing))?.accessToken);
  }

  async hasLinkedCalendar(existing?: ISupplierAppsMobiscrollConnect | null): Promise<boolean> {
    return Boolean((await this.resolveData(existing))?.connectedCalendars?.length);
  }

  async isStaleOAuthSession(existing?: ISupplierAppsMobiscrollConnect | null): Promise<boolean> {
    const data = await this.resolveData(existing);
    return !!data?.accessToken && !data?.connectedCalendars?.length;
  }

  async getConnectedCalendar(
    existing?: ISupplierAppsMobiscrollConnect | null,
  ): Promise<ISupplierAppsMobiscrollConnectCalendar | undefined> {
    return (await this.resolveData(existing))?.connectedCalendars?.[0];
  }

  async findConnectedCalendar(
    calendarId: string,
    provider: ISupplierCalendarExternalProvider,
    existing?: ISupplierAppsMobiscrollConnect | null,
  ): Promise<ISupplierAppsMobiscrollConnectCalendar | undefined> {
    return (await this.resolveData(existing))?.connectedCalendars?.find(
      (calendar) => calendar.calendarId === calendarId && calendar.provider === provider,
    );
  }
}
